import { Button } from "@bcc/components/ui/button";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";
import { Eye } from "lucide-react";

interface InvoiceActionsCellProps extends CellContext<PurchaseOrderInvoice, unknown> {
  onViewDetails?: (invoice: PurchaseOrderInvoice) => void;
}

export const InvoiceActionsCell = (props: InvoiceActionsCellProps) => {
  const invoice = props.row.original;
  const { onViewDetails } = props;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        onViewDetails?.(invoice);
      }}
    >
      <Eye className="h-4 w-4" />
    </Button>
  );
};
